import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'av-bool-cell',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule, MatTooltip],
  templateUrl: './av-bool-cell.component.html',
  styleUrls: ['./av-bool-cell.component.scss'],
})
export class AvBoolCellComponent {
  readonly value = input<boolean | null>(null);
}
